import { createPortal } from 'react-dom';
import React from 'react';
import { ToastProvider } from '@heroui/react';

/**
 * ProfileToasts — the profile pages' toast region, above the credential
 * drawer.
 *
 * HeroUI renders the region in place (no portal) at `z-[100]`, inside the
 * page's stacking context, while the drawer is portaled to <body> at
 * `z-[1060]` (above the legacy top menu) — a save made in the drawer toasted
 * underneath it. Portaling the region to <body> and lifting it past the
 * drawer puts the toast on top.
 */
function ProfileToasts() {
	if (typeof document === 'undefined') return null;
	return createPortal(
		<ToastProvider
			placement="top-right"
			toastOffset={80}
			regionProps={{ classNames: { base: '!z-[1070]' } }}
		/>,
		document.body
	);
}

export default ProfileToasts;
